<template>
    <div id="container">
<div id="content">
            <student-nav selected="emergency-evac" :id="student_id" :name="name" :uni="uni" :status="status"></student-nav>
            <br clear="all">
            <div style="position:relative">
                <student-emergency-evac-edit :id="evac_id" :student_id="student_id" :student_name="name"></student-emergency-evac-edit>
            </div>            
        </div>
        </div>
</template>

<script>
    import axios from 'axios'



    export default {
        metaInfo () {
            return {
                title: this.name + " - " + this.uni + " | " + this.status
            }
        },

        components: {
        },
        data () {
            return {
                evac_id: 0,
                student_id: 0,
                name: "",
                uni: "",
                status: "",
                haStatus: ""
            }
        },
        methods: {
            getStudent: function () {
                //get the student id from the url
                var urlParams = this.$route.query;

                this.student_id = location.pathname.split('/student/emergency-evacuation-edit/')[1];
                this.evac_id = urlParams["evac_id"]
                axios.get("/api/student/" + this.student_id)
                    .then(response => {
                        this.name = response.data.title;
                        this.uni = response.data.uni;
                        this.status = response.data.statusDisplay;
                        this.haStatus = response.data.haStatus;
                    });
            }
        },
        created () {
            this.getStudent();
        }
    }
</script>
<style scoped>
</style>
